import React from 'react';
import { Link } from 'react-router-dom';
import PageHero from '@/components/PageHero';
import FadeInUp from '@/components/FadeInUp';
import { ArrowRight, CertificateIcon } from '@/components/icons';

const UNITS = [
  { id: '10851', desc: 'Operate a powered industrial lift truck fitted with forks', level: '3', credits: '7' },
  { id: '10852', desc: 'Operate a powered industrial lift truck fitted with attachments', level: '3', credits: '3' },
  { id: '18496', desc: 'Issued in conjunction with “F” Endorsement', level: '—', credits: '—' },
];

export default function NZQA() {
  return (
    <>
      <PageHero
        eyebrow="NZQA Unit Standards"
        title="Formal NZQA credits, alongside your training."
        subtitle="Gain formal NZQA assessment credits for your record of learning. An additional fee applies per trainee, in addition to Standard or Beginner course charges."
        image="/generated/certification.png"
        breadcrumbs={[{label:'Home', to:'/'}, {label:'Courses', to:'/courses'}, {label:'NZQA Unit Standards'}]}
        badge="Optional Extra — Advise at Booking"
      />

      <section className="nft-container py-16 lg:py-20">
        <FadeInUp>
          <div className="max-w-3xl">
            <div className="label-eyebrow text-[#FC4E2C] mb-3">Already NZQA Registered?</div>
            <p className="text-[#060D9C]/85 leading-relaxed text-base lg:text-lg">
              Bring your NZQA (NSN) number on the day. We’ll record assessment outcomes against your record of learning so credits flow directly to your profile.
            </p>
          </div>
        </FadeInUp>

        {/* Unit standards table */}
        <FadeInUp>
          <div className="mt-10 surface-card overflow-hidden" data-testid="nzqa-unit-standards-table">
            <div className="hidden md:grid md:grid-cols-12 gap-3 bg-[#060D9C] text-white px-6 py-4">
              <div className="md:col-span-2 label-eyebrow text-[#FC4E2C]">Unit</div>
              <div className="md:col-span-7 label-eyebrow text-[#FC4E2C]">Description</div>
              <div className="md:col-span-1 label-eyebrow text-[#FC4E2C]">Level</div>
              <div className="md:col-span-2 label-eyebrow text-[#FC4E2C]">Credits</div>
            </div>
            <div>
              {UNITS.map((u, i) => (
                <div key={u.id} className={`grid grid-cols-1 md:grid-cols-12 gap-3 px-6 py-5 ${i < UNITS.length - 1 ? 'border-b border-[#060D9C]/10' : ''}`}>
                  <div className="md:col-span-2 font-mono-cert text-lg text-[#060D9C] font-bold">{u.id}</div>
                  <div className="md:col-span-7 text-sm text-[#060D9C]/85">
                    <div className="label-eyebrow text-[#060D9C]/55 mb-0.5 md:hidden">Description</div>
                    {u.desc}
                  </div>
                  <div className="md:col-span-1 text-sm">
                    <div className="label-eyebrow text-[#060D9C]/55 mb-0.5 md:hidden">Level</div>
                    <span className="font-bold">{u.level}</span>
                  </div>
                  <div className="md:col-span-2 text-sm">
                    <div className="label-eyebrow text-[#060D9C]/55 mb-0.5 md:hidden">Credits</div>
                    <span className="inline-flex items-center gap-1.5">
                      <span className="w-7 h-7 rounded-md bg-[#2D8653]/15 text-[#2D8653] flex items-center justify-center">
                        <CertificateIcon width={14} height={14} />
                      </span>
                      <span className="font-bold">{u.credits}</span>
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </FadeInUp>

        <FadeInUp>
          <div className="mt-8 callout-steel">
            <div className="label-eyebrow text-[#FC4E2C] mb-1">How it works</div>
            <p className="text-sm text-[#060D9C]/85">
              Advise us at the time of booking that you’d like to add an NZQA assessment. On the day, simply bring your NSN number. Assessments run alongside your normal course, with results submitted to NZQA after a successful pass.
            </p>
          </div>
        </FadeInUp>

        <div className="mt-10 text-center">
          <Link to="/booking" className="btn-primary-orange">
            Add NZQA to my booking <ArrowRight width={18} height={18} />
          </Link>
        </div>
      </section>
    </>
  );
}
